import {Model} from '../base.model';

export type InvoiceCargoTypeName = 'Documents' | 'Cargo' | 'Pallet' | 'TiresWheels' | 'Money' | 'Parcel';

export class InvoiceCargoType extends Model {
  id: InvoiceCargoTypeName;
  description: string;
}
